var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWireshark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 64,
    viewBox: "0 0 128 128",
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.28125 5.4375c-2.682851 0-4.84375 2.203877-4.84375 4.90625v98c0 2.70237 2.160899 4.9375 4.84375 4.9375h98.125c2.68285 0 4.875-2.23513 4.875-4.9375v-98c0-2.702373-2.19215-4.90625-4.875-4.90625zm2.75 5.25h92.625c1.30678 0 2.34375 1.036968 2.34375 2.34375v75.46875h-21.73586c-6.101069-8.427999-13.354345-36.539277-2.125-58.90625-23.716084-.402267-51.06381 29.76345-51.07664 58.90625h-22.375v-75.46875c0-1.306782 1.036968-2.34375 2.34375-2.34375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireshark);
export default __webpack_public_path__ + "static/media/wireshark.21a1ffb12cf8bf64133b8459cab38ac8.svg";
export { ForwardRef as ReactComponent };